import type { SimpleRequestConfig } from 'modules/app/types';

import * as types from './actionTypes';

const simpleRequests: Record<string, SimpleRequestConfig> = {
  [types.FETCH_WHITELIST]: {},
  [types.CREATE_WHITELIST]: {
    notifications: {
      success: { id: 'page.config.whitelist.create.success', defaultMessage: 'License plate created successfully.' },
      failure: { id: 'page.config.whitelist.create.failure', defaultMessage: 'An error occurred during the license plate creation.' }
    }
  },
  [types.UPDATE_WHITELIST]: {
    notifications: {
      success: { id: 'page.config.whitelist.update.success', defaultMessage: 'License plate updated successfully.' },
      failure: { id: 'page.config.whitelist.update.failure', defaultMessage: 'An error occurred during the license plate update.' }
    }
  },
  [types.DELETE_WHITELIST]: {
    notifications: {
      success: { id: 'page.config.whitelist.delete.success', defaultMessage: 'License plate deleted successfully.' },
      failure: { id: 'page.config.whitelist.delete.failure', defaultMessage: 'An error occurred during the license plate deletion.' }
    }
  }
};

export default simpleRequests;
